import React, { memo } from 'react';

import { useMutation } from '@tanstack/react-query';

import Table from '../../Table';
import Pagination from '../../Pagination';
import CallRecording from './CallRecording';
import AssociateWithBorrower from './AssociateWithBorrower';

import usePagination from '../../../hooks/usePagination';
import { useUiContext } from '../../../context/UiContext';
import FreshcallerCallService from '../../../services/FreshcallerCallService';

function CallsTable() {
  const { showToast } = useUiContext();

  const {
    currentPage,
    switchToPage,
    pageTotal,
    isFetching,
    data: unassociatedCalls,
    refetch,
  } = usePagination({
    queryKey: ['unassociatedCalls'],
    queryFn: FreshcallerCallService.getUnassociatedFreshcallerCalls,
  });

  const { mutate: excludeFromLog } = useMutation({
    mutationFn: (row) =>
      FreshcallerCallService.updateFreshcallerCall({
        callId: row.id,
        borrowerId: row.borrower_id,
        excludeFromLog: true,
      }),
    onSuccess: () => {
      showToast({
        text: 'Success',
        type: 'success',
      });
      refetch();
    },
    onError: (error) => {
      console.log(error);
      showToast({
        text: error?.response?.data?.message || 'Something went wrong',
        type: 'error',
      });
    },
  });

  const cols = [
    {
      title: 'Date',
      keys: ['call_data.created_time'],
      type: 'date',
    },
    {
      title: 'Number',
      keys: ['doesntmatter'],
      format: (value, row) => {
        const customer = row.call_data.participants.find(
          (p) => p.participant_type !== 'Agent'
        );

        return customer?.caller_number || '';
      },
    },
    {
      title: 'Direction',
      keys: ['call_data.direction'],
      type: 'badge',
      badgeColor: (value) => {
        switch (value) {
          case 'outgoing':
            return 'emerald';
          default:
            return 'blue';
        }
      },
    },
    {
      title: 'Recording',
      keys: ['doesntmatter2'],
      type: 'component',
      component: CallRecording,
      props: (row) => {
        return {
          call: row,
        };
      },
    },
    {
      title: 'Borrower',
      keys: ['doesntmatter3'],
      type: 'component',
      component: AssociateWithBorrower,
      props: (row) => {
        return {
          call: row,
          refetch,
        };
      },
    },
    {
      title: 'Exclude from log',
      keys: ['exclude_from_log'],
      type: 'checkbox',
      onChange: (row) => {
        excludeFromLog(row);
      },
    },
  ];

  return (
    <div>
      <Table
        cols={cols}
        rows={unassociatedCalls?.items}
        title=""
        isFetching={isFetching}
        minHeight={565}
        total={unassociatedCalls?.itemsTotal}
      />
      <Pagination
        pageTotal={pageTotal}
        switchToPage={switchToPage}
        currentPage={currentPage}
      />
    </div>
  );
}

export default memo(CallsTable);
